import * as React from 'react';
import isNil from 'lodash/isNil';

import { NewTableProps } from './new-table.types';
import { TableView } from './components/table-view';
import { useController } from './controller';
import { Actions } from './components/actions';
import { FieldSelector } from '@common/components/FieldSelector';
import { Filters } from './components/filters';
import { MessageBox } from '../MessageBox';

export const NewTable: React.FC<NewTableProps> = (props) => {
  const { loadMetadata, noDataMessage, columns, classes, filters, moduleName, columnsManagement, infiniteScroll, itemUniqProperty, rowActions, columnsResizing } = props;
  const {
    tableInstance,
    currentActions,
    processedColumnActions,
    isOpenedFieldSelector,
    processedHeaderActions,
    currentContextMenuColumnId,
    areOpenedFilters,
    actions,
    isLoading,
    shouldHaveRowClickHandler,
    currentColumn,
    messageProps,
    closeMessage,
    showMessage,
    applyColumnFilters,
    closeFilters,
    handleLazyLoad,
    handleColumnSizeChange,
    handleRowContextMenu,
    isRowSelected,
    handleRowClick,
    handleSort,
    handleHeaderCellContextMenu,
    getMenuHorizontalPosition,
    closeHeaderActions,
    closeFieldSelector,
    handleColumnAdd,
    handleHeaderContextMenu,
  } = useController(props);

  return (
    <>
      <MessageBox
        hideMessageBox={closeMessage}
        {...messageProps}
      />
      {isOpenedFieldSelector && columnsManagement && (
        <FieldSelector 
          withSearch
          getFolders={columnsManagement.getFolders}
          getFields={columnsManagement.getFields}
          onChange={handleColumnAdd}
          close={closeFieldSelector}
        />
      )}
      {areOpenedFilters && filters && currentColumn && (
        <Filters
          showMessage={showMessage}
          moduleName={moduleName}
          filterName={typeof currentColumn?.header === 'number' || typeof currentColumn?.header === 'string'
            ? currentColumn?.header
            : undefined
          }
          defaultValue={loadMetadata?.filtering?.columns && !isNil(currentContextMenuColumnId) 
            ? loadMetadata?.filtering.columns[currentContextMenuColumnId] 
            : undefined}
          filters={filters.operators}
          onClose={closeFilters}
          onApply={applyColumnFilters}
          {...currentColumn?.filterProps}
        />
      )} 
      {currentActions?.coords && actions && (
        <Actions 
          style={{
            ...getMenuHorizontalPosition(currentActions.coords.x),
            top: currentActions.coords.y,
          }}
          columnId={currentContextMenuColumnId!}
          className="Table__actions"
          items={actions}
          onClose={closeHeaderActions}
        />
      )}
      <TableView
        isLoading={isLoading}
        classes={classes}
        columns={columns}
        currentColumnResizeOffset={tableInstance.getState().columnSizingInfo.deltaOffset || undefined}
        isRowSelected={isRowSelected}
        itemUniqProperty={itemUniqProperty}
        noDataMessage={noDataMessage}
        model={tableInstance}
        loadTableMetadata={loadMetadata}
        onRowContextMenu={rowActions?.length ? handleRowContextMenu : undefined}
        onColumnResizeEnd={columnsResizing ? handleColumnSizeChange : undefined}
        onSort={handleSort}
        onRowClick={shouldHaveRowClickHandler ? handleRowClick : undefined}
        onHeaderContextMenu={processedHeaderActions.length ? handleHeaderContextMenu : undefined}
        onCellContextMenu={processedColumnActions?.length ? handleHeaderCellContextMenu : undefined}
        onLazyLoad={infiniteScroll ? handleLazyLoad : undefined}
      />
    </>
  );
};

NewTable.defaultProps = {
  loadItemsCount: 45,
};